<template>
  <div class="process-header">
    <div class="d-flex align-center justify-space-between mb-4">
      <h2 class="text-h5 primary--text">{{ title }}</h2>
      <v-btn icon @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <p class="text-body-2">{{ description }}</p>
    <v-divider class="mt-4"></v-divider>
  </div>
</template>

<script>
export default {
  name: 'MassiveProcessHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="css" scoped>
.process-header {
  padding: 20px;
}
</style>
